/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2022-11-28
 */

/**
 * Minimum Viewport (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

(() => {
	const MIN_WIDTH = 360;

	const vp = document.querySelector('meta[name="viewport"]');
	function fn() {
		const v = window.outerWidth > MIN_WIDTH ? 'width=device-width,initial-scale=1' : `width=${MIN_WIDTH}`;
		if (vp.getAttribute('content') !== v) {
			vp.setAttribute('content', v);
		}
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
})();

/**
 * Back To Top
 *
 * @author Takuto Yanagida
 * @version 2022-10-18
 */

(() => {
	function init() {
		const OFFSET_Y = 0;

		const btn = document.getElementById('back-to-top');
		if (btn === null) return;
		const ph  = btn.parentElement;

		onScroll(scrollHandler);
		onResize(scrollHandler);
		if ('ontouchstart' in window) window.addEventListener('touchmove', scrollHandler);
		setTimeout(scrollHandler, 100);

		function scrollHandler() {
			// const btnR = btn.getBoundingClientRect();
			// const btnH = (btnR.bottom - btnR.top);

			const viewBottomY = window.innerHeight + OFFSET_Y/* - btnH*/;
			const footerTopY = ph.getBoundingClientRect().top;

			if (viewBottomY > footerTopY) {
				btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY) + 'px)';
				btn.classList.remove('fixed');
			} else {
				btn.style.transform = '';
				btn.classList.add('fixed');
			}

			if (window.pageYOffset > window.innerHeight / 3) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		}
	}


	// -------------------------------------------------------------------------


	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

	const resizeListeners = [];
	const scrollListeners = [];

	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}

	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}

	document.addEventListener('DOMContentLoaded', () => {
		window.addEventListener('resize', () => {
			for (const l of resizeListeners) l();
		}, { passive: true });
		window.addEventListener('scroll', () => {
			for (const l of scrollListeners) l();
		}, { passive: true });
	});

	init();
})();

/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2022-07-11
 */

 document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.user-content *[class^="button"]');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (!btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		return f.classList.contains('frame') || f.classList.contains('frame-alt');
	}

	function setEventListener(btn) {
		btn.classList.add('toggle');
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		f.style.display = 'none';
		f.classList.add('hidden');
		setTimeout(() => { f.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		if (visible) {
			f.classList.remove('hidden');
		} else {
			f.classList.add('hidden');
		}
	}

});

/**
 * Toggle Button of Shortcut Navigation
 *
 * @author Space-Time Inc.
 * @version 2022-11-24
 */

document.addEventListener('DOMContentLoaded', () => {
	const ls = document.querySelectorAll('.shortcut-nav > .menu > li.group > label');
	for (const l of ls) {
		l.addEventListener('click', () => {
			l.classList.toggle('open');
		});
	}
});

/**
 * Site Header Background and Archive Background
 *
 * @author Space-Time Inc.
 * @version 2022-11-29
 */

document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.part-top-visual')) return;

	const hbg = document.querySelector('.part-site-header-bg');
	const sh  = document.querySelector('.site-header');
	const eh  = document.querySelector('.entry-header');

	const isArch = document.body.classList.contains('archive');
	const sc     = isArch ? document.querySelector('.site-content')  : null;
	const ec     = isArch ? document.querySelector('.entry-content') : null;

	if (hbg) hbg.classList.add('compact');

	const isPra   = document.querySelector('.part-related-activity');
	const article = isPra ? isPra.parentElement : null;
	const list    = isPra ? isPra.querySelector('.list-item-activity') : null;

	let st = null;
	function fn() {
		clearTimeout(st);
		st = setTimeout(() => {
			if (hbg && sh && eh) {
				const b1 = sh.getBoundingClientRect();
				const b2 = eh.getBoundingClientRect();
				const h1 = b2.bottom - b1.top;
				hbg.style.setProperty('--header-bg-height', `${h1}px`);

				hbg.classList.add('visible');
			}
			if (sc && ec) {
				const b3 = sc.getBoundingClientRect();
				const b4 = ec.getBoundingClientRect();
				const h2 = b4.top - b3.top;
				sc.style.setProperty('--content-bg-top', `${h2}px`);

				sc.classList.add('bg-visible');
			}
			if (article && list) {
				const b1 = article.getBoundingClientRect();
				const b2 = list.getBoundingClientRect();
				const h  = b1.bottom - b2.top;
				article.style.setProperty('--entry-bg-height', `${h}px`);

				article.classList.add('bg-visible');
			}
		}, 100);
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
});

/**
 * Header Navigation Misc.
 *
 * @author Space-Time Inc.
 * @version 2022-09-26
 */

document.addEventListener('DOMContentLoaded', () => {
	const btn = document.querySelector('#menu-button-search');
	if (!btn) return;

	const panel = document.querySelector('#panel-search');
	if (!panel) return;

	btn.addEventListener('click', () => {
		btn.parentElement.classList.toggle('open');
		panel.classList.toggle('open');
	});
});


document.addEventListener('DOMContentLoaded', () => {
	const header = document.querySelector('.site-header');

	const mg0 = document.getElementById('mg0');
	function onBeforeOpen() {
		if (header.classList.contains('full')) {
			if (window.innerHeight / 2 < mg0.getBoundingClientRect().top) {
				mg0.scrollIntoView({ block: 'start', behavior: 'smooth' });
			}
		}
	}
	const args = {
		autoClose      : false,
		doSetPanelWidth: true,
		onBeforeOpen   : onBeforeOpen,
		doOpenOnHover  : false,
	};
	GIDA.menu_global('mg0', args);
});
